import PropTypes from 'prop-types';
import cn from 'classnames';

import './nameValuePairs.scss';

export default function NameValuePairs ({items = [], className = ''}) {
  return (
    <div className={cn('name-value-pairs', className)}>
      {
        items.map((item, index) => {
          return (
            <span key={index} className='name-value-pair'>
              <span>{item.label + ':'} </span>
              <span>{item.value ?? ''}</span>
            </span>
          )
        })
      }
    </div>
  )
}

NameValuePairs.propTypes = {
  items : PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
  })
  ),
  className: PropTypes.string
};
